import { render, staticRenderFns } from "./pixel-tracker.vue?vue&type=template&id=43b838bd&"
import script from "./pixel-tracker.vue?vue&type=script&lang=js&"
export * from "./pixel-tracker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports